export default [
  {
    name: "booking-payment-provider-stripe",
    path: "/booking-payment-provider-stripe",
    component: () => import(/*webpackChunkName: "companies" */ "@/pages/booking-payment-providers/StripeCallback"),
  }
]
